import { render, staticRenderFns } from "./bhlist.vue?vue&type=template&id=1a90dd7c&"
import script from "./bhlist.vue?vue&type=script&lang=js&"
export * from "./bhlist.vue?vue&type=script&lang=js&"
import style0 from "./bhlist.vue?vue&type=style&index=0&id=1a90dd7c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports